// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xaSi","field":"styles_field__2oVXt","fieldCol":"styles_fieldCol__HAnG6","diffCol":"styles_diffCol__1Pgww","diff":"styles_diff__3KQ3u"};